import { Link } from "react-router-dom";
import { useShop } from "../context/ShopContext";
import { waLink } from "../lib/constants";
import { WhatsAppIcon } from "./icons";

export const Footer = () => {
  const { settings, collections } = useShop();
  const year = new Date().getFullYear();

  const nav = [
    { label: "Accueil", to: "/" },
    { label: "La Collection", to: "/parfums" },
  ];

  return (
    <footer className="bg-noir text-ivory/80">
      <div className="wrap grid gap-12 py-16 sm:py-20 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <h2 className="font-serif text-5xl leading-none text-ivory">Vāsam</h2>
          <p className="mt-2 text-[10px] uppercase tracking-[0.4em] text-champagne">Maison de fragrances</p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/60">
            Découvrez votre signature olfactive. Une sélection raffinée de parfums d'exception, pour elle et pour lui.
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="eyebrow text-ivory/40">Navigation</p>
          <ul className="mt-5 space-y-3">
            {nav.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-ivory/70 transition-colors hover:text-champagne" data-testid={`footer-link-${n.to === "/" ? "accueil" : "parfums"}`}>
                  {n.label}
                </Link>
              </li>
            ))}
            {collections.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/parfums?collection=${c.slug}`}
                  className="text-sm text-ivory/70 transition-colors hover:text-champagne"
                  data-testid={`footer-collection-${c.slug}`}
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="eyebrow text-ivory/40">Commander</p>
          <ul className="mt-5 space-y-3 text-sm">
            {settings.whatsapp_number && (
              <li>
                <a
                  data-testid="footer-whatsapp-link"
                  href={waLink(settings.whatsapp_number, "Bonjour, je souhaite découvrir la collection Vāsam.")}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-ivory/70 transition-colors hover:text-champagne"
                >
                  <WhatsAppIcon className="h-4 w-4" /> WhatsApp — commande directe
                </a>
              </li>
            )}
            {settings.contact_email && (
              <li>
                <a href={`mailto:${settings.contact_email}`} className="text-ivory/70 transition-colors hover:text-champagne">
                  {settings.contact_email}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="wrap flex flex-col items-center justify-between gap-3 py-6 text-[11px] text-ivory/40 sm:flex-row">
          <p>© {year} Vāsam — Tous droits réservés.</p>
          <p data-testid="chogan-mention" className="text-center">
            Vāsam, fondée par Carine · Consultante Chogan indépendante · Distribution indépendante.
          </p>
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-ivory/70">
            Espace consultante
          </Link>
        </div>
      </div>
    </footer>
  );
};
